// -----------------------------------------------------------------------------
// <copyright file="global.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>

import { environment } from '../../../environments/environment';

// ------------------------------------------------------------------------------
export const BASE_API_URL = environment.baseUrl;
export const PENDO_BASE_API_URL = 'https://app.pendo.io/';
export const PENDO_DEFAULT_ACCOUNT_ID = 'GLOBAL-ACCOUNT-VAS';
export const APP_NAME = 'VAS';
// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const PSPDFKIT_KEY = environment.psPdfKey;
export const USER_ROLE_KEY = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

export const MAX_VALUE = 999999999999.99;
export const SpecialCharacters = {
  DOLLAR: '$',
  AMPERSAND: '&',
  PLUS: '+',
  COMMA: ',',
  FORWARD_SLASH: '/',
  COLON: ':',
  SEMI_COLON: ';',
  EQUALS: '=',
  QUESTION_MARK: '?',
  AT_SYMBOL: '@',
  SPACE: ' ',
  HASH: '#',
  PERCENTAGE: '%',
  QUOTES: "'",
  DOUBLEQUOTES: '"',
  PERIOD: '.',
  APN: '-',
  ASTERISK: '*',
};

export const SpecialCharactersHexValue = {
  DOLLAR: '%24',
  AMPERSAND: '%26',
  PLUS: '%2B',
  COMMA: '%2C',
  FORWARD_SLASH: '%2F',
  COLON: '%3A',
  SEMI_COLON: '%3B',
  EQUALS: '%3D',
  QUESTION_MARK: '%3F',
  AT_SYMBOL: '%40',
  SPACE: '%20',
  HASH: '%23',
  PERCENTAGE: '%25',
  QUOTES: '%27',
  DOUBLEQUOTES: '%22',
  PERIOD: '%2E',
  APN: '%2D',
  ASTERISK: '%2A',
};

export const MENUS = {
  BIDBOARD: 'BID_BOARD',
  PROJECTLIST: 'PROJECT_LIST',
  PROJECTDASHBOARD: 'PROJECT_DASHBOARD',
  POSTBIDBOARD: 'POST_BID_BOARD',
};

export const STATUS_LIST = {
  HFRPendingApproval: 'p.hpa',
  HFRPerCustomer: 'p.hpc',
  // PartialRelease: 'p.pr',
  ReleasedForProduction: 'p.rfp',
};
export enum SUBMITTAL_STATUS {
  Requested = 1,
  SentForApproval = 2,
  Approved = 3,
  ApprovedAsNoted = 4,
  Rejected = 5,
  NeedsRevision = 6,
  Received = 7,
  RevisionRequested = 8,
  Downloaded = 9,
  Removed = 10,
}
export const DATE_CONFIG = {
  monthFormat: 'MMMM, YYYY',
  closeOnSelect: true,
  openOnClick: true,
  format: 'MMM DD YYYY',
  firstDayOfWeek: 'mo',
  inputElementContainer: null,
};

export const NOTIFICATION_TYPES = {
  CoraInvoice: 'Cora Invoice',
  TrakIt: 'Trak-it',
  Warehouse: 'Warehouse',
};
export const CORA_LINK = 'https://wesco-ap-prod.herokuapp.com/v2/auth/login';
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const COLOR_CODES = [
  '#631774',
  '#970547',
  '#ff1f72',
  '#e896dd',
  '#41daff',
  '#7fb835',
  '#1eb50c',
  '#f96408',
  '#03728c',
  '#bad1d6',
  '#915c46',
  '#0052cc',
  '#00a3bf',
  '#00875a',
  '#ff991f',
  '#de350d',
  '#5243aa',
  '#8581ff',
  '#fb7fa7',
  '#c3b300',
  '#fda8a8',
  '#172b4e',
  '#cca096',
  '#ae87b0',
  '#99c893',
  '#669c7e',
  '#668cc3',
  '#7e7866',
  '#b652ff',
];

export const ROUTING_MAP = {
  BIDS: 'bid-board',
  PROJECT: 'project-dashboard',
  PROJECT_INDEX: 'quote/project-list',
};

export const STATUS_IdS = [
  '2d5c1891-d321-45f0-9c47-2b8596749529',
  'db1b48e4-c15a-4d9f-ae8f-79dc7dfb4ea5',
];

export const BLANK_IMPORT_MNF = '(blank)';

export enum DiscrepancyType {
  None = 'None',
  Unmatched = 'Unmatched',
  Overshipped = 'Overshipped',
  Damaged = 'Damaged',
  ReceivedShort = 'ReceivedShort',
}
export const resolutionType = {
  AcknowledgeReceiveShort: 'Acknowledged',
  Overshipped: 'Overshipped',
  ScrapMaterial: 'Scrap Material',
  Keep: 'Keep',
  SendBack: 'Send Back',
  MapExisting: 'Map to Existing',
  AddasChild: 'Add as Child',
};
export const discType = {
  ReceivedShort: 'Received Short',
  Unmatched: 'Unmatched',
  Overshipped: 'Overshipped',
  Damaged: 'Damaged',
};

export const PMResolutionAction = {
  KeepToStore: 'Keep',
  KeepToCharge: 'Keep',
};

export const WAREHOUSE_ROLES = ['WarehouseAssociate', 'WarehouseManager']; // for now both manager and associate are some.handled like this.but need to change it in future

export const RESTRICTED_FILES_EXT = [
  'exe',
  'apk',
  'bat',
  'jsr',
  'bin',
  'ipsw',
  'ios',
  'xapk',
  'jar',
  'zip',
  'msg',
];

export const NEW_TAB_EXT = ['jpg', 'jpeg', 'png', 'pdf'];

export const PROJECT_LOOKUP = {
  BID_STATUS_LIST: 'quote_bid_statuses_list',
  BID_TYPE_LIST: 'quote_bid_types_list',
  BRANCH_LIST: 'quote_branch_list',
  FILE_CATEGORY_LIST: 'quote_file_category_list',
  FILE_DOCUMENT_TAG: 'quote_file_category_list',
  QUOTE_FILTER_LIST: 'quote-list-filters',
  CPO_QUOTE_FILTER_LIST: 'cpo-quote-list-filters',
  MFR_LIST: 'mfr-list',
  PROJECT_LEDGER: 'project-ledger',
};

export const SEARCH_CATEGORIES_LIST = [
  'AssignedUsers',
  'Customers',
  'OSRs',
  'Branches',
  'Teams',
  'Suppliers',
  'ERPSONumbers',
  'ERPPONumbers',
  'PONumbers',
  'AreaNames',
  'MfrReps',
  'LeadTimes',
  'ShipVias',
  'CPOId',
  'SPOId',
  'ShipToAddresses',
  'SIMMfrs',
  'ProductTypes',
  'SalesOrders',
  'Types',
  'MFRParts',
  'Mfrs',
  'FactoryOrderNumbers',
  'SupplierLines',
];

export interface UserContext {
  Id: string;
  AzureUserId: string;
  BusinessUnitId: string;
  DefaultSalesLocation?: string;
  Token: string | null;
  CurrencyJson?: string;
}
